export const updateQueryParam = (key: string, value?: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  if (value) {
    searchParams.set(key, value);
  } else {
    searchParams.delete(key);
  }
  const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
  window.history.replaceState({}, "", newUrl);
};

export const getQueryParam = (key: string): string =>
  new URLSearchParams(window.location.search).get(key) || "";
